import React, { useEffect, useRef, useState } from "react";
import "./NavMenu.scss";
import "../NavMenu/NavMenu.scss";
import CinderBuildImg from "../../Assets/Images/cinderbuild-logo-svg.svg";
import CinderBuildImgWhite from "../../Assets/Images/cb-logo-white.png";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "Components/AuthProvider/AuthProvider";
import questionIcon from "../../Assets/Images/icon/message-question-icon.png";
import login from "../../Assets/Images/login.png";
import logoutIco from "../../Assets/Images/logout.png";
import { getUserRolePart } from "Helpers";
import { ModalPrompt } from "Components";
import CartMenu from "Layout/NavMenu/Cart/CartMenu";
// import cart from '../../Assets/Images/cart-new.png';
// import profile from '../../Assets/Images/profile.png';
// import userCircle from "../../Assets/Images/user-cirlce-add.png";
// import profileCircle from "../../Assets/Images/icon/profile-circle.png";

type navMenuprops = {
  variant?: string;
  allProperties?: string;
  company?: "construction" | "realEstate" | "ecommerce";
};

const NavMenu: React.FC<navMenuprops> = ({
  variant,
  allProperties,
  company,
}) => {
  const navigate = useNavigate();

  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  const linkPart = getUserRolePart(user);
  console.log("linkPart", linkPart);

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [logoutShow, setLogoutShow] = useState<boolean>(false);

  function logoutNow(): void {
    setLogoutShow(!logoutShow);
  }

  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScroll(window.pageYOffset > 200);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // const [scroll, setScroll] = useState(false);
  // const [isScrolling, setIsScrolling] = useState(false);

  // useEffect(() => {
  //   let scrollTimeout: number;

  //   const onScroll = () => {
  //     setIsScrolling(true);

  //     setScroll(window.pageYOffset > 200);

  //     window.clearTimeout(scrollTimeout);
  //     scrollTimeout = window.setTimeout(() => {
  //       setIsScrolling(false);
  //     }, 1000);
  //   };

  //   window.addEventListener("scroll", onScroll);

  //   return () => {
  //     window.removeEventListener("scroll", onScroll);
  //     window.clearTimeout(scrollTimeout);
  //   };
  // }, []);

  return (
    <nav
      className={`navMenuLPV2 ${allProperties} ${scroll ? 'isFixed' : ''}`}
    >
      <div className={`container navSecondCon ${variant}`}>
        <div className="firstCon">
          <div className="imgCon">
            <Link to="/">
              <img
                src={
                  company === "construction"
                    ? CinderBuildImg
                    : company === "realEstate"
                      ? CinderBuildImgWhite
                      : ""
                }
                alt="logo"
                className="logoImg"
              />
            </Link>
          </div>
          <div className="divider"></div>
          <ul
            className={`${
              company === "realEstate" ? "estateProperty" : ""
            } unOrderedList`}
          >
            <Link className="navLink" to="/estate-home">
              <li>Real Estate</li>
            </Link>
            <Link className="navLink" to="/construction-home">
              <li>Building Material</li>
            </Link>
            <Link className="navLink" to="/enterprise-home">
              <li>Corporate</li>
            </Link>
            <Link className="navLink" to="/about">
              <li>About Us</li>
            </Link>
            {!user && (
              <Link className="navLink" to="/v2/buyer/contact-us">
                <li>Get in Touch</li>
              </Link>
            )}
          </ul>
        </div>

        <div className="navSecondCon2">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            {user && (
              <div className="noticeCartProfileCon">
                <li className="nav-item noticeCon">
                  <Link
                    className="nav-link nav-responsive"
                    to={"v2/buyer/notification"}
                  >
                    {" "}
                    <img src={questionIcon} alt="" className="nav-icon" />
                  </Link>
                </li>
                <li className="nav-item d-none">
                  <Link className="nav-link nav-responsive" to="/buyer/saved">
                    {" "}
                    <img src={questionIcon} alt="" className="nav-icon" /> Saved
                    List
                  </Link>
                </li>
                <li className="nav-item noticeCon">
                  <CartMenu></CartMenu>
                </li>

                <li className="nav-item dropdown">
                  <button
                    className="nav-link nav-responsive d-flex align-items-center cursor-pointer noticeCon"
                    id="navbarDropdown6"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="profile-initials">
                      {user?.firstName[0]}
                      {user?.lastName[0]}
                    </span>
                  </button>
                  <ul
                    className="dropdown-menu dropdown-menu-end border-0 shadow"
                    aria-labelledby="navbarDropdown6"
                  >
                    <li>
                      <Link
                        className="dropdown-item"
                        to={user ? "/v2/buyer" : "/login"}
                        // to={
                        //   user?.isInvestor === true
                        //     ? "/estate-managers/subscriber-projects"
                        //     : user?.isSeller === false
                        //       ? `${linkPart}`
                        //       : `${linkPart}/orders`
                        // }
                      >
                        {" "}
                        <img src={login}></img> My Account
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item d-none"
                        to={user ? "/v2/buyer/orders" : "/login"}

                        // to={`${linkPart}/my-orders`}
                      >
                        {" "}
                        <img src={login}></img> My Orders
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={user ? "/v2/buyer/quote-requests" : "/login"}

                        // to={`${linkPart}/quote-requests`}
                      >
                        {" "}
                        <img src={login}></img> Quote Requests
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item d-none" to="/login">
                        {" "}
                        <img src={login}></img> Switch to Seller
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item text-danger"
                        to="#"
                        onClick={logoutNow}
                      >
                        {" "}
                        <img src={logoutIco}></img> Log out
                      </Link>
                    </li>
                  </ul>
                </li>
              </div>
            )}
          </ul>
        </div>

        {!user && (
          <div className="getStartedCon">
            <Link to="/login">
              <h4>Sign in</h4>
            </Link>
            <Link to="/register">
              <button className="heroBtn heroBtn-filled">Get Started</button>
            </Link>
          </div>
        )}
      </div>
      <ModalPrompt
        showModal={logoutShow}
        action={() => {
          logout();
          navigate("/login", { replace: true });
        }}
        closeModal={() => setLogoutShow(false)}
        message={"Are you sure you want to logout?"}
      ></ModalPrompt>
    </nav>
  );
};

export default NavMenu;
